import type { EtsyDataSource, EtsyListing, EtsyShop } from "./contracts.js";
import { MOCK_FEATURED_LISTING_IDS, MOCK_LISTINGS, MOCK_SHOP } from "./fixtures/mock-etsy.js";

function clone<T>(value: T): T {
  return structuredClone(value);
}

export class MockEtsyDataSource implements EtsyDataSource {
  readonly kind = "mock" as const;

  async findShops(shopName: string): Promise<EtsyShop[]> {
    const normalized = shopName.toLowerCase();
    const aliases = [MOCK_SHOP.shop_name.toLowerCase(), "northstar", "demo", "mock"];
    return aliases.includes(normalized) ? [clone(MOCK_SHOP)] : [];
  }

  async getShop(shopId: number): Promise<EtsyShop | null> {
    return shopId === MOCK_SHOP.shop_id ? clone(MOCK_SHOP) : null;
  }

  async getFeaturedListings(shopId: number, limit: number): Promise<EtsyListing[]> {
    if (shopId !== MOCK_SHOP.shop_id) return [];
    return clone(MOCK_LISTINGS.filter((item) => MOCK_FEATURED_LISTING_IDS.includes(item.listing_id)).slice(0, limit));
  }

  async getActiveListings(shopId: number, limit: number): Promise<EtsyListing[]> {
    return shopId === MOCK_SHOP.shop_id ? clone(MOCK_LISTINGS.slice(0, limit)) : [];
  }

  async getListingsByIds(listingIds: number[]): Promise<EtsyListing[]> {
    const ids = new Set(listingIds);
    return clone(MOCK_LISTINGS.filter((item) => ids.has(item.listing_id)));
  }
}
